var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileNafil = function SvgProfileNafil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.806,
    height: 30.806,
    viewBox: "0 0 8.151 8.151",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M451.238 364.118h19.893v13.901h-19.893z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.586 93.977a3.25 3.25 0 0 1-3.251 3.251 3.25 3.25 0 0 1-3.251-3.25 3.25 3.25 0 0 1 3.25-3.252 3.25 3.25 0 0 1 3.252 3.251z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.171706,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-141.676 -110.705) scale(1.22136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35 92.688a1.016 1.016 0 0 1-1.015 1.016 1.016 1.016 0 0 1-1.017-1.016 1.016 1.016 0 0 1 1.017-1.016 1.016 1.016 0 0 1 1.016 1.016z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.194638,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-141.676 -110.705) scale(1.22136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.752 94.116c.483.825.893.802 1.297-.005.403-.807 1.699 1.561 1.615 1.269-1.17 1.095-2.634 1.754-4.577 0 .107.03 1.183-2.088 1.665-1.264.483.825 0 0 0 0z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 0.0344093,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-141.676 -110.705) scale(1.22136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.152 95.483-.338.507.338.272zm2.438-.011.336.507-.337.272z",
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "green",
      strokeWidth: ".15235px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-141.676 -110.705) scale(1.22136)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "5.33333px",
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline",
      fill: "green"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m459.371 365.481 3.467 1.728v.176l-.384-.176h-3.083zm0-.373 3.467 1.728v.187l-3.467-1.728zm0-.39 3.467 1.74v.191l-3.467-1.744zm0-.373 3.467 1.739v.187l-3.467-1.74zm0-.362 3.467 1.728v.186l-3.467-1.738zm0-.38 1.648.828v-.827h1.819v1.91l-3.467-1.723z",
    "aria-label": "N",
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal"
    },
    transform: "translate(-101.535 -78.26) scale(.23032)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m121.629 95.3.045-.033.061.084-.045.033zm.009.158.041-.038.07.076-.04.038z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.0463266,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-141.676 -110.705) scale(1.22136)"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileNafil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profileNAFIL.e2e371ae.svg";
export { ForwardRef as ReactComponent };